import { classNames } from "../../lib/class-names";
import Badge from "../ui/badge/badge";
import BoxIcon from "../ui/box-icon/box-icon";
import "./intro-section-badge.scss";

type IntroBadgePropsT = {
  title: string;
  bgColor: "light" | "dark";
  badgeText?: string;
  boxIcon?:
    | "primary"
    | "secondary"
    | "tertiary"
    | "primary-rounded"
    | "secondary-rounded"
    | "tertiary-rounded";
  text?: string;
  icon?: string;
};

const IntroSectionBadge = ({
  badgeText,
  title,
  text,
  boxIcon,
  icon,
  bgColor = "light",
}: IntroBadgePropsT) => {
  const titleClassNames = classNames({
    "intro-section-badge__title": true,
    "intro-section-badge__title--light": bgColor === "light",
    "intro-section-badge__title--dark": bgColor === "dark",
  });
  const textClassNames = classNames({
    "intro-section-badge__text": true,
    "intro-section-badge__text--light": bgColor === "light",
    "intro-section-badge__text--dark": bgColor === "dark",
  });
  return (
    <div className="intro-section-badge">
      {boxIcon && icon && (
        <div className="intro-section-badge__box-icon">
          <BoxIcon icon={icon} size={"medium"} type={boxIcon} />
        </div>
      )}
      {badgeText && (
        <div className="intro-section-badge__badge">
          <Badge text={badgeText} icon={icon} />
        </div>
      )}
      <h2 className={titleClassNames}>{title}</h2>
      {text && <p className={textClassNames}>{text}</p>}
    </div>
  );
};

export default IntroSectionBadge;
